var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipantMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "32px",
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_mic_off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.6666667,18.3333333 L28.8333333,18.3333333 C28.8333333,19.5666667 28.5666667,20.7166667 28.1166667,21.75 L30.1666667,23.8 C31.1,22.1666667 31.6666667,20.3166667 31.6666667,18.3333333 L31.6666667,18.3333333 Z M24.9666667,18.6166667 C24.9666667,18.5166667 25,18.4333333 25,18.3333333 L25,8.33333333 C25,5.56666667 22.7666667,3.33333333 20,3.33333333 C17.2333333,3.33333333 15,5.56666667 15,8.33333333 L15,8.63333333 L24.9666667,18.6166667 L24.9666667,18.6166667 Z M7.11666667,5 L5,7.11666667 L15.0166667,17.1333333 L15.0166667,18.3333333 C15.0166667,21.1 17.2333333,23.3333333 20,23.3333333 C20.3666667,23.3333333 20.7333333,23.2833333 21.0833333,23.2 L23.85,25.9666667 C22.6666667,26.5166667 21.35,26.8333333 20,26.8333333 C15.4,26.8333333 11.1666667,23.3333333 11.1666667,18.3333333 L8.33333333,18.3333333 C8.33333333,24.0166667 12.8666667,28.7166667 18.3333333,29.5333333 L18.3333333,35 L21.6666667,35 L21.6666667,29.5333333 C23.1833333,29.3166667 24.6166667,28.7833333 25.9,28.0333333 L32.8833333,35 L35,32.8833333 L7.11666667,5 L7.11666667,5 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 83.3333333,
    height: 83.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 83.3333333,
    height: 83.3333333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v1-Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Video-Patient-Profile-page-:-Consult-Expanded-In-Conference-Patient-Both-Muted",
    transform: "translate(-1373.000000, -156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_mic_off",
    transform: "translate(1368.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Red,-End-Call",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.666667, -21.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "White",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "White-Copy",
    stroke: "none",
    fill: "#E82121",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantMicOff);
export default __webpack_public_path__ + "static/media/participantMicOff.e45313845154cbbb63636db02c1bb534.svg";
export { ForwardRef as ReactComponent };